module.exports = __webpack_public_path__ + "media/images/reportimages/digital_innovation-552eec07b40614926483301d351d6822.png";